<ion-content class="network-error">
  <div class="page-container">
    <img src="../../../assets/img/probleme_de_connexion.svg" alt="network-error" />
    <p>
      {{"NETWORK.ERROR"|translate}}
    </p>
  </div>
</ion-content>
